<template>
  <DelDialog
    width="480px"
    :dialogVisible="visible"
    @handleClose="handleCancel"
    @handleConfirm="handleConfirm"
  >
    <template #title>{{$t('jobManagementV2.editor')}}</template>
    <el-form ref="form"
      :model="form"
      :rules="rules"
      :hide-required-asterisk="true"
    >
      <el-form-item prop="name" :label="$t('projectV2.projectName')">
        <el-input v-model.trim="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="deliveryTime" :label="$t('projectV2.limitTime')">
        <el-date-picker
          v-model="form.deliveryTime"
          type="datetime"
          :picker-options="pickerOptions"
          :placeholder="$t('projectV2.selectDate')"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item class="remark" :label="$t('jobManagementV2.remark')">
        <el-input show-word-limit resize="none" maxlength="70" type="textarea" v-model="form.remark"></el-input>
      </el-form-item>
    </el-form>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import { updateProject } from '@/services/jobManagement'

export default {
  name: 'EditProject',
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    editProject: {
      type: Object,
      require: true,
    },
  },
  components: {
    DelDialog
  },
  data () {
    var checkLimitTime = (rule, value, callback) => {
      if (this.form.deliveryTime == null) {
        return callback(new Error(this.$t('projectV2.limitTimeNullText')))
      } else if (new Date(new Date(this.form.deliveryTime).setMinutes(new Date(this.form.deliveryTime).getMinutes() + 1)) < new Date()) {
        return callback(new Error(this.$t('projectV2.limitTimeErrorText')))
      } else {
        callback();
      }
    }
    return {
      pickerOptions: {
        disabledDate (a) {
          return a.getTime() < new Date().getTime() - 86400000;
        }
      },
      form: {
        id: 0,
        name: '',
        deliveryTime: '',
        remark: '',
        isAutoCommit: 0,
        isUseMemory: 0,
        projectProcessType: 1,
      },
      rules: {
        name: [
          { required: true, message: this.$t('projectV2.nameErrorText'), trigger: 'blur' },
          { min: 1, max: 50, message: this.$t('newProjectV2.projectNameLength'), trigger: 'blur' }
        ],
        deliveryTime: [
          { validator: checkLimitTime, trigger: 'blur', required: true }
        ]
      },
    }
  },
  methods: {
    handleCancel () {
      this.$refs.form.clearValidate();
      this.$emit('handleCancel');
    },
    handleConfirm () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let { success } = await updateProject(this.form);
          if (success) {
            this.$message.closeAll();
            this.$message.success(this.$t('projectV2.editSuccess'));
            this.handleCancel();
            this.$emit('updateProjectInfo');
          }
        } else {
          return false;
        }
      });
    },
  },
  watch: {
    editProject: {
      handler (newVal) {
        this.form.id = newVal.id;
        this.form.name = newVal.name;
        this.form.isAutoCommit = newVal.isAutoCommit;
        this.form.isUseMemory = newVal.isUseMemory;
        this.form.projectProcessType = newVal.projectProcessType;
        this.form.deliveryTime = newVal.deliveryTime + ':00';
        this.form.remark = newVal.remark;
      },
      deep: true,
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>